import type {
  CompensationListResponse,
  CompensationResponse,
  CreateCompensationInput,
} from '@kora/types';
import { apiRequest } from './client.js';

/**
 * Compensations API. Thin wrappers around /v1/compensations endpoints.
 * Contract in apps/api/src/routes/compensations.ts + @kora/types.
 */

export function listCompensations(employeeId: string): Promise<CompensationListResponse> {
  const qs = new URLSearchParams({ employeeId }).toString();
  return apiRequest<CompensationListResponse>(`/v1/compensations?${qs}`);
}

export function createCompensation(
  input: CreateCompensationInput,
): Promise<CompensationResponse> {
  return apiRequest<CompensationResponse>('/v1/compensations', {
    method: 'POST',
    body: input,
  });
}
